/* eslint-disable */
function trackPageview(pt, pp) {
	gtag('config', 'UA-99799566-3', { page_title: pt, page_path: pp });
	// console.log(`track pageview: ${pt}, ${pp}`);
}

function trackEvent(a, c, l) {
	gtag('event', a, { event_category: c, event_label: l });
	// console.log(`track event: ${a}, ${c}, ${l}`);
}

export { trackPageview };
export { trackEvent };

export default {
	methods: {
		trackPageview,
		trackEvent,
	},
};



// WEBPACK FOOTER //
// ./src/mixins/tracking.js